
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue9 as ObiWindTrue9Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-9.js';
 
 
 

 
 export const ObiWindTrue9 = createComponent({
   react: React,
   tagName: 'obi-wind-true-9',
   elementClass: ObiWindTrue9Element,
   events: {
     
   }
  });
 
 